import { VideoService } from '@/services';
import collect from 'collect.js';
import { writable } from 'svelte/store';
const initialState = {
    items: [],
    preview: {
        timeline: [],
        src: ''
    },
    hasData: false,
    has1080: false
};
// Init state
const { subscribe, update } = writable(initialState);
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    reset: () => {
        update(store => ({ ...store, ...initialState }));
    },
    async fetchAvailableFormats(url, source) {
        await new VideoService().fetchFormats(url, source).then(response => {
            if (response) {
                let has1080 = collect(response).firstWhere('value', '1080') ? true : false;
                update(fs => {
                    return {
                        ...fs,
                        items: response,
                        hasData: true,
                        has1080: has1080
                    };
                });
            }
        });
    },
    async fetchVideoPreview(url, source) {
        await new VideoService().fetchVideoPreview(url, source).then(response => {
            update(fs => {
                return {
                    ...fs,
                    preview: response
                };
            });
        });
    }
};
const formats = {
    ...actions,
    subscribe
};
export default formats;
